import axios from "axios";
import history from "../history";

export function checkLocalStorage() {
  try {
    return JSON.parse(localStorage.auth).token;
  } catch (err) {
    localStorage.removeItem("auth");
    window.location.href = "/#/login";
  }
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_CRM_API,
  // timeout: 1000,
});

instance.interceptors.response.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.response && error.response.status) {
      if (error.response.status === 401) {
        localStorage.removeItem("auth");
        history.push("/login");
      }
    }
    return Promise.reject(error);
  }
);

export const login = function (email, password) {
  const req = instance.post("login", {
    email,
    password,
  });
  return req;
};

export const logoutApp = function (params) {
  const req = axios.post(process.env.REACT_APP_LOGOUT_APP, {
    ...params,
    key: "nippon_axvsdfdffjlsjdfjds",
  });
  return req;
};

export const fetchMember = function (id) {
  let token = checkLocalStorage();
  const req = instance.get("members/" + id, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchMemberNoti = function (id, params) {
  let token = checkLocalStorage();
  const req = instance.get("members-notify/" + id, {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchMembers = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("members", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchStaff = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("staffs", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchLocation = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("locations", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchDealer = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("dealers", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchDLDealer = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("v1/dl-dealers", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchMemberJob = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("member-job-roles", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchBank = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("banks", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchBankBranch = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("bank-branchs", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchMemberChangeLog = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("members-changed-logs", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchTransactionLog = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("transaction-logs", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchBonusPointLog = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("bonus-point-logs", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchNote = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("notes", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchFile = function (params) {
  const req = axios.get(process.env.REACT_APP_FILE_API + "files", {
    params,
  });
  return req;
};

export const fetchUsers = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("users", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchPromotions = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("promotions", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchMemberYearlyPoint = function (member_id) {
  const req = axios.get(
    process.env.REACT_APP_REPORT_API + "v1/year/" + member_id,
    {
      params: {
        key: "dgUQr1UKtm79",
      },
    }
  );
  return req;
};

export const fetchNotifications = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("notifications", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchGroupProduct = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("product-groups", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const postNote = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("notes", data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const putMember = function (data) {
  let token = checkLocalStorage();
  const req = instance.put("members", data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const postMember = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("members", data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const putMemberBank = function (member_id, data) {
  let token = checkLocalStorage();
  const req = instance.put("members-bank/" + member_id, data, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.auth).token,
    },
  });
  return req;
};

export const postFile = function (data) {
  const req = axios.post(process.env.REACT_APP_FILE_API + "file", data, {
    headers: {
      // Authorization: 'Bearer ' + token
    },
  });
  return req;
};

export const deleteFile = function (id) {
  const req = axios.delete(process.env.REACT_APP_FILE_API + "file/" + id, {
    headers: {
      // Authorization: 'Bearer ' + token
    },
  });
  return req;
};

export const updateStatusMember = function (member_id, data) {
  let token = checkLocalStorage();
  const req = instance.put("members-status/" + member_id, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const fetchDetailPromotion = function (id) {
  let token = checkLocalStorage();
  const req = instance.get("promotions/" + id, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const changeMemberScore = function (member_id, data) {
  let token = checkLocalStorage();
  const req = instance.put("members-point/" + member_id, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const putBank = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put("bank-branchs/" + id, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const postBranch = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("bank-branchs", data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const deleteBranch = function (id) {
  const req = axios.delete(
    process.env.REACT_APP_FILE_API + "/bank-branchs/" + id,
    {
      headers: {
        // Authorization: 'Bearer ' + token
      },
    }
  );
  return req;
};

export const postBank = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("banks", data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const postMemberChangeLog = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("members-changed-logs", data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

// get list user group
export const getUserGroup = (params) => {
  let token = checkLocalStorage();
  const req = instance.get("/users", {
    params,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

// get usergroup detail
export const getUserGroupDetail = (id) => {
  let token = checkLocalStorage();
  const req = instance.get(`/users/${id}`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

// get list permission user group
export const getPermissionByGroup = (params) => {
  let token = checkLocalStorage();
  const req = instance.get("/rbac-modules", {
    params,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

// get permission by user group
export const getPermissionUser = (idUser) => {
  let token = checkLocalStorage();
  const req = instance.get(`/user-roles/${idUser}`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

// update user group
export const updateUsergroup = (data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(data);
    }, 2000);
  });
};

// update permission user group
export const updateUsergroupPermission = (data, id) => {
  let token = checkLocalStorage();
  const req = instance.put(`/user-roles/${id}`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const postMemberVerify = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("member-verify-logs", data, {
    baseURL: process.env.REACT_APP_DASHBOARD_API,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const fetchDetailMemberCaution = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("stats/detail-member-caution", {
    params: params,
    baseURL: process.env.REACT_APP_DASHBOARD_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchDetailMemberBarcode = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("stats/detail-member-barcode", {
    params: params,
    baseURL: process.env.REACT_APP_DASHBOARD_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const fetchMemberReports = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("v1/statistic-files", {
    params: params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const exportMemberReport = function (id) {
  let token = checkLocalStorage();
  const req = instance.get("file/" + id, {
    responseType: "blob",
    params: { download: true },
    baseURL: process.env.REACT_APP_FILE_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const searchDealers = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("/v1/dl-dealers-search", {
    params: params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const resetMemberPassword = (id, data) => {
  let token = checkLocalStorage();
  const req = instance.put(`/members-random-password/${id}`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const resetUserPassword = (id) => {
  let token = checkLocalStorage();
  const req = instance.put(
    `/users-random-password/${id}`,
    {},
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
  return req;
};

export const resetPasswordOnFirstLogin = (id, data) => {
  let token = checkLocalStorage();
  const req = instance.put(`/users-password/${id}`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const getRegisterMemberList = (params) => {
  let token = checkLocalStorage();
  const req = instance.get("/v1/create-member-requests", {
    params,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const getRegisterMemberById = (id) => {
  let token = checkLocalStorage();
  const req = instance.get(`/v1/create-member-requests/${id}`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const updateRegisterMemberStatus = (id, data) => {
  let token = checkLocalStorage();
  const req = instance.put(`/v1/create-member-requests-status/${id}`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const updateRegisterMember = (id, data) => {
  let token = checkLocalStorage();
  const req = instance.put(`/v1/create-member-requests/${id}`, data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const uploadImageMember = (formData) => {
  return axios.post(`${process.env.REACT_APP_FILE_API}file`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export { instance };

export const createCampaignsApi = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("campaigns", data, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getCampaignsListApi = function (params) {
  let token = checkLocalStorage();

  const req = axios.get("campaigns", {
    params,
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getCampaignsDetailApi = function (id) {
  let token = checkLocalStorage();

  const req = axios.get(`campaigns/${id}`, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getCampaignsResultsApi = function ({ id, params }) {
  let token = checkLocalStorage();

  const req = axios.get(`campaigns/${id}/result`, {
    params,
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getCampaignResultDetailApi = function (id) {
  let token = checkLocalStorage();

  const req = axios.get(`feedbacks/${id}`, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getMembersTemplateInCampaign = function () {
  const token = checkLocalStorage();

  return axios.get(`members/example`, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
    responseType: "blob",
  });
};

export const exportCampaignResultList = function (id, filter) {
  const token = checkLocalStorage();

  return axios.get(`campaigns/${id}/result/export`, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
    params: {
      ...filter,
      page: undefined,
      limit: undefined,
    },
    responseType: "blob",
  });
};

export const checkMembersInCampaign = function (data) {
  let token = checkLocalStorage();
  const req = instance.post("members/validate", data, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getCampaignChangeHistoryList = function (id) {
  let token = checkLocalStorage();

  const req = axios.get(`/campaigns/${id}/logs`, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getAreaList = function () {
  let token = checkLocalStorage();

  const req = axios.get(`areas`, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const updateCampaignApi = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`/campaigns/${id}`, data, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const updateCampaignStatus = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`/campaigns/${id}/status`, data, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const updateCampaignResultStatus = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`/feedbacks/${id}/status`, data, {
    baseURL: process.env.REACT_APP_CAMPAIGN_API,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getBarcodeListApi = (params) => {
  let token = checkLocalStorage();
  const req = instance.get("/v1/product_entity", {
    params,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const checkingImportBarcodeQrcode = (data) => {
  let token = checkLocalStorage();
  const req = instance.post(
    "/v1/product_entity/checking-barcode-qrcode",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
  return req;
};

export const importBarcodeQrcode = (data) => {
  let token = checkLocalStorage();
  const req = instance.post("/v1/product_entity/import-barcode-qrcode", data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const fetchLocationV2 = function (params) {
  let token = checkLocalStorage();
  const req = instance.get("v1/locations", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const updateLocationV2 = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`v1/locations/${id}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const checkInBarcodeQrcode = (data) => {
  let token = checkLocalStorage();
  const req = instance.post("/v1/product_entity/checkin-barcode-qrcode", data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const activeBarcodeQrcode = (data) => {
  let token = checkLocalStorage();
  const req = instance.post("/v1/product_entity/active-barcode-qrcode", data, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  return req;
};

export const deactiveBarcodeQrcode = (data) => {
  let token = checkLocalStorage();
  const req = instance.post(
    "/v1/product_entity/deactive-barcode-qrcode",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
  return req;
};

// Redemption management
export const getRedemptionPeriodList = function (params) {
  let token = checkLocalStorage();

  const req = instance.get("/v1/redemption-periods", {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getRedemptionPeriodDetail = function (params) {
  let token = checkLocalStorage();
  const req = instance.get(`/v1/redeem-requests`, {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const getRedemptionConfigurationList = function (params) {
  let token = checkLocalStorage();
  const req = instance.get(`/v1/redemption-configs`, {
    params,
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const addPaymentDateAndCloseRedemption = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`/v1/redemption-periods/${id}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const approveRejectRedemptionRequests = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`/v1/redeem-requests-status/${id}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const updateRedemptionConfiguration = function (id, data) {
  let token = checkLocalStorage();
  const req = instance.put(`/v1/redemption-configs/${id}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const createRedemptionConfiguration = function (data) {
  let token = checkLocalStorage();
  const req = instance.post(`/v1/redemption-configs`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const checkRedemptionRequests = function (data) {
  let token = checkLocalStorage();
  const req = instance.post(`/v1/checking-redeem-request-status`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};

export const importRedemptionRequests = function (data) {
  let token = checkLocalStorage();
  const req = instance.post(`/v1/import-redeem-request-status`, data, {
    headers: { Authorization: "Bearer " + token },
  });
  return req;
};